jQuery(document).ready(function($){

  $("[data-jd-open-search]").click(function(){
    $("#jd-search").addClass("jd-active");
    $("sticky-header").addClass("jd-search-active");
    $("sticky-header").addClass("ma_color-sand");
    $("[data-jd-open-search]").addClass("ma-hidden");
    $("[data-jd-close-search]").removeClass("ma-hidden");
    LogoWhite();
  });

  $("[data-jd-close-search]").click(function(){
    $("#jd-search").removeClass("jd-active");
    $("sticky-header").removeClass("jd-search-active");
    $("sticky-header").removeClass("ma_color-sand");
    $("[data-jd-close-search]").addClass("ma-hidden");
    $("[data-jd-open-search]").removeClass("ma-hidden");
    LogoBlack();
  });
  function LogoBlack() {
    // This is commented because it was annoying 
    return;
    // https://cdn.shopify.com/s/files/1/0601/9226/0262/files/logo-black.svg?v=1719593356
    if(!jQuery("body").hasClass("template-index") && !jQuery("body").hasClass("about") && !jQuery("body").hasClass("template-collection")) {
      jQuery(".header__heading-logo-wrapper img").attr("src", "https://cdn.shopify.com/s/files/1/0601/9226/0262/files/deepsleepdarklogo.png?v=1727472437");
      var newSrcset = "https://cdn.shopify.com/s/files/1/0601/9226/0262/files/deepsleepdarklogo.png?v=1727472437 150w, https://cdn.shopify.com/s/files/1/0601/9226/0262/files/deepsleepdarklogo.png?v=1727472437 225w, https://cdn.shopify.com/s/files/1/0601/9226/0262/files/deepsleepdarklogo.png?v=1727472437 300w";
      jQuery(".header__heading-logo-wrapper img").attr("srcset", newSrcset);
    }
  }
  function LogoWhite() {
    // https://cdn.shopify.com/s/files/1/0601/9226/0262/files/logo-w.svg?v=1719593354
      jQuery(".header__heading-logo-wrapper img").attr("src", "https://cdn.shopify.com/s/files/1/0601/9226/0262/files/deepsleepwhitelogo.png?v=1727472437");
      var newSrcset = "https://cdn.shopify.com/s/files/1/0601/9226/0262/files/deepsleepwhitelogo.png?v=1727472437 150w, https://cdn.shopify.com/s/files/1/0601/9226/0262/files/deepsleepwhitelogo.png?v=1727472437 225w, https://cdn.shopify.com/s/files/1/0601/9226/0262/files/deepsleepwhitelogo.png?v=1727472437 300w";
      jQuery(".header__heading-logo-wrapper img").attr("srcset", newSrcset);
  }
  LogoBlack();
  // Menu Link color change when hover on mega menu
    jQuery("li.ma-has-submenu").mouseenter(function(){
      jQuery(".header__icon--search svg.icon-close").trigger("click");
      if (jQuery(this).hasClass("ma_mega_active_menu")) {
        jQuery("sticky-header").addClass("ma_color-sand");
        LogoWhite();
      }
    });
    // if mouse outside of li.mega menu and mega menu div
    var div1Class = "li.ma_mega_active_menu";
    var div2Class = ".ma_mega_menu_wrap";
  
    // Flag to track if the mouse is outside both divs
    var outsideBoth = false;
  
    jQuery(div1Class).mouseenter(function() {
      outsideBoth = false; // Reset flag upon entering div1
    }).mouseleave(function() {
      outsideBoth = true;
      checkMousePosition();
    });
  
    jQuery(div2Class).mouseenter(function() {
      outsideBoth = false; // Reset flag upon entering div2
    }).mouseleave(function() {
      outsideBoth = true;
      checkMousePosition();
    });
  
    function checkMousePosition() {
      // Check if the mouse is outside both divs (manually)
      if (outsideBoth && !jQuery(document).find(div1Class).is(":visible")) {
        outsideBoth = false; // Reset flag for next time
        jQuery("sticky-header").removeClass("ma_color-sand");
        LogoBlack();
        // You can add your desired actions here (e.g., toggle a class)
      } else if (outsideBoth && !jQuery(document).find(div2Class).is(":visible")) {
        outsideBoth = false; // Reset flag for next time
        jQuery("sticky-header").removeClass("ma_color-sand");
        LogoBlack();
        // You can add your desired actions here (e.g., toggle a class)
      }
    }

  
    /*jQuery(".ma_mega_menu_wrap").mouseleave(function(){
        jQuery("sticky-header").removeClass("ma_color-sand");
        LogoBlack();
    });*/
    // Sticky Header Logo Change
    // $(window).scroll(function() {
    //   var scrollY = jQuery(window).scrollTop();
    //   if(scrollY > 10){
    //      LogoWhite(); 
    //   }else if(scrollY < 10){
    //     LogoBlack();
    //   }else{
    //     // nothing
    //   }
    // });
  // Mega Menu Mobile
  jQuery("nav.menu-drawer__navigation ul li").on("click", function (e) {
    var childElement = jQuery(this).children("div.ma_mega_menu_wrap, ul.menu-drawer__menu");

    // Toggle clicked menu instead of just adding an "open" class
    if (childElement.length) {
      jQuery("nav.menu-drawer__navigation ul li .ma_mega_menu_wrap").not(childElement).removeClass("ma_open_submenu");
      jQuery("nav.menu-drawer__navigation ul li ul.menu-drawer__menu").not(childElement).removeClass("ma_open_submenu");
    
        childElement.toggleClass("ma_open_submenu");
       
        } else {
          // Close everything if clicking outside of any submenu
          jQuery("nav.menu-drawer__navigation ul li ul, nav.menu-drawer__navigation ul li .ma_mega_menu_wrap").removeClass("ma_open_submenu");
    }

    // Handle active parent highlighting
    jQuery("nav.menu-drawer__navigation ul li").removeClass("active_parent");
    if (childElement.hasClass("ma_open_submenu")) {
        jQuery(this).addClass("active_parent");
    }
});

  
  $("summary.header__icon--menu svg.icon-hamburger").click(function(){
    $("sticky-header").addClass("jd-search-active");
    $("#jd-search").removeClass("jd-active");
    LogoWhite();
    jQuery("sticky-header").addClass("ma_color-sand");
  });
  $("summary.header__icon--menu svg.icon-close").click(function(){
    $("sticky-header").removeClass("jd-search-active");
    $("#jd-search").removeClass("jd-active");
    jQuery("sticky-header").removeClass("ma_color-sand");
    LogoBlack();
  });

  // mobile search button
  jQuery(".ma_search_mob_btn img").on("click", function(e){
      jQuery(".menu-drawer-container").removeClass("menu-opening");
      jQuery("#jd-search").toggleClass("jd-active");
  });
    
  // Mobile Menu Search Close Button
  jQuery(".close-search-btn").on("click", function(e){
    e.preventDefault();
      jQuery(".menu-drawer-container").addClass("menu-opening");
      
      // jQuery("sticky-header").removeClass("jd-search-active");
      jQuery("#jd-search").removeClass("jd-active");
  });

  // Mobile Menu Shop Button
  jQuery(".ma_search_shop_btn a").on("click", function(e){
      jQuery(".menu-drawer-container").removeClass("menu-opening");
      jQuery(".menu-drawer-container").removeAttr("open");
      jQuery("sticky-header").removeClass("jd-search-active");
      jQuery("#jd-search").removeClass("jd-active");
  });
  
  // blog side navigation
    var toc = '<div class=""><h3>Navigation:</h3><ul>';
    jQuery('.blogdetail-content-block h2, .utilitypage-cnt-points-each-block h3').each(function(index){
      var vid = "step" + (index + 1);  // +1 for starting from step1
        jQuery(this).attr('id', vid);
        var id = jQuery(this).attr('id');
        var text = jQuery(this).text();
        toc += '<li><a href="#' + id + '">' + text + '</a></li>';
    });
    toc += '</ul></div>';
    jQuery('.jd-toc').html(toc);

    var offset = 130; // Adjust the offset value as needed

    // Function to update the active class based on scroll position
    function updateActiveClass() {
        var scrollPosition = jQuery(window).scrollTop() + offset;
        jQuery('.blogdetail-content-block h2, .utilitypage-cnt-points-each-block h3').each(function(){
            var id = jQuery(this).attr('id');
            var offsetTop = jQuery(this).offset().top - offset;
            var nextOffsetTop = (jQuery(this).next('h2').length > 0) ? jQuery(this).next('h2').offset().top - offset : jQuery(document).height();

            if (scrollPosition >= offsetTop && scrollPosition < nextOffsetTop) {
                jQuery('.jd-toc li').removeClass('active');
                jQuery('.jd-toc a[href="#' + id + '"]').parent().addClass('active');
            }
        });
    }

    // Bind the function to the scroll event
    jQuery(window).on('scroll', function() {
        updateActiveClass();
    });

    // Update the active class on page load
    updateActiveClass();

    // Add click event to Table of Contents links
    jQuery('.jd-toc a').on('click', function(event) {
        event.preventDefault(); // Prevent the default anchor click behavior
        jQuery('.jd-toc li').removeClass('active');
        jQuery(this).parent().addClass('active');

        var target = jQuery(this).attr('href');
        var targetOffset = jQuery(target).offset().top - 150;

        // Animate scrolling to the target element with offset
        jQuery('html, body').animate({
            scrollTop: targetOffset
        }, 500);
    });

  
  jQuery(".up-cnt-nav-mainvb-block").on("click", function(){
      jQuery(".utilitypage-navpopup-block").show();
  });
  jQuery(".utilitypage-navpopup-block .jd-toc a").on("click", function(){
      jQuery(".utilitypage-navpopup-block").hide();
  });
  
  jQuery(".faqs-tabs-list a").on("click", function(e){
      e.preventDefault();
      jQuery("a.btn-def").removeClass("btn-faq-active");
      jQuery(this).addClass("btn-faq-active");
      var tab = jQuery(this).attr("data-target");
      jQuery(".tabs").hide();
      jQuery("."+tab).show();
  });
  // product features
 jQuery(".key-features h3").on("click", function(e){
      e.preventDefault();
    if (jQuery(this).hasClass("active")) {
        // If already active, remove active class and close the section
        jQuery(this).removeClass("active");
        jQuery(this).parent().find("ul, span").slideUp();
    } else {
        // Otherwise, activate the clicked item and deactivate others
        jQuery(".key-features h3").removeClass("active");
        jQuery(this).addClass("active");

        // Close all other sections
        jQuery(".key-features ul, .key-features span").slideUp();

        // Open the clicked one
        jQuery(this).parent().find("ul, span").slideDown();
    }
  });
  
  // product features
  jQuery(".more-features h3").on("click", function(e){
      e.preventDefault();
      jQuery(".more-features h3").removeClass("active");
      jQuery(this).addClass("active");
      jQuery(this).parent().find("p").slideToggle();
  });
  // Collection Filters
  jQuery("a.main-parent-vehicle-btn").on("click", function(e){
    var href = jQuery(this).attr("href");
      if (href && href.indexOf('#') === -1) {
          console.log("");
      }else{
        e.preventDefault();
        jQuery(this).toggleClass("active-vehicle-btn");
        jQuery(this).parent().find("ul.shop-by-vehicle-main-sub-list").slideToggle();
      }
  });
  jQuery("h3.mob_shop_cat").on("click", function(e){
      e.preventDefault();
      jQuery(this).parent().find("ul").slideToggle();
  });
  //FAQs Toggel
  jQuery(".faq-item h3").on("click", function(e){
      e.preventDefault();
      jQuery(".faq-item").removeClass("active");
      jQuery(this).closest(".faq-item").addClass("active");
  });
  jQuery(".ma_vehicle_box").on("click", function(e){
      e.preventDefault();
     var data_tab = jQuery(this).attr("data-tab");
      jQuery(".ma_vehicle_box").removeClass("active");
      jQuery(this).addClass("active");
      jQuery(".model_list").removeClass("active");
      jQuery("."+data_tab).addClass("active");
  });
  // 404 Rotate hover Image
  jQuery('.f-o-f-block').hover(function() {
      var randomAngle = Math.floor(Math.random() * (360 - 0 + 1)) + 0; // Generate random angle between 0 and 360 degrees
      jQuery(this).find(".f-o-f-main-o-block .f-o-f-starimg").css('transform', 'rotate(' + randomAngle + 'deg)');
    }, function() {
      jQuery(this).find(".f-o-f-main-o-block .f-o-f-starimg").css('transform', 'none'); // Reset rotation on hover out
  });
  
  // Home banner CTA
  jQuery('.ma-hero-cta').on("click", function(e) {
    e.preventDefault(); // Prevent default jump
    console.log("cta clicked")

    var targetId = $(this).attr("href");

    console.log("target id is: ", targetId)
        if (!targetId || targetId === "#") return; 

        targetId = targetId.replace(/^\/#/, '#'); // Remove leading `/` from `/#someid`
        
        var targetElement = $(targetId);

        console.log("target element is: ", targetElement)
        if (targetElement.length) {
            $("html, body").animate(
                { scrollTop: targetElement.offset().top }, 
                800
            );
        }
});

  // Home Product Slider
  $('.ma_slider_wrapper').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    speed: 300,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          slidesToShow: 1
        }
      }
    ]
  });
  // Blog Slider
  $('.ma_blog_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    speed: 300,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: true,
          slidesToShow: 1
        }
      }
    ],
    prevArrow:"<a href='#' class='slick-prev'>Previous<img class='a-left control-c prev' src='https://cdn.shopify.com/s/files/1/0602/6684/0154/files/slick-next.svg?v=1718004474'></a>",
    nextArrow:"<a href='#' class='slick-next'>Next <img class='a-right control-c next' src='https://cdn.shopify.com/s/files/1/0602/6684/0154/files/slick-next.svg?v=1718004474'></a>"
  });
  // Home Brands Logo
  $('.brands_logo_carousel').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: false,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    dots: false,
    speed: 300,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 360,
        settings: {
          arrows: false,
          slidesToShow: 1
        }
      }
    ]
  });
});


